const monthlyPaymentModal = () => {
    const MODAL_ID = 'monthly-payment';
    const modal = document.querySelector(`[data-estate-modal="${MODAL_ID}"]`);
    if (!modal) return;

    const priceSelect = modal.querySelector('.js-monthly-price');
    const rateSelect = modal.querySelector('.js-monthly-rate');
    const termSelect = modal.querySelector('.js-monthly-term');
    const downSelect = modal.querySelector('.js-monthly-down');
    const bonusInput = modal.querySelector('.js-monthly-bonus');
    const borrowingEl = modal.querySelector('.js-monthly-borrowing');
    const resultEl = modal.querySelector('.js-monthly-result');

    const triggers = document.querySelectorAll(`[data-estate-modal-open="${MODAL_ID}"]`);
    if (triggers.length === 0) return;

    const getBuildingLabel = (trigger) => {
        const building = trigger
            .closest('.c-cards-residence')
            ?.querySelector('.c-cards-residence__building');
        return building?.textContent.trim() || '';
    };

    const getPriceOptions = () => {
        const options = Array.from(triggers)
            .map((trigger) => ({
                price: parseInt(trigger.dataset.monthlyPrice, 10) || 0,
                building: getBuildingLabel(trigger),
            }))
            .filter(({ price }) => price > 0);

        return options.filter((option, index) => (
            options.findIndex((candidate) => (
                candidate.price === option.price && candidate.building === option.building
            )) === index
        ));
    };

    const populatePriceOptions = (selectedPrice, selectedBuilding) => {
        const priceOptions = getPriceOptions();
        priceSelect.innerHTML = '';

        priceOptions.forEach(({ price, building }) => {
            const option = document.createElement('option');
            option.value = price;
            option.textContent = building
                ? `${building}： ${price.toLocaleString('ja-JP')}万円`
                : `${price.toLocaleString('ja-JP')}万円`;
            if (price === selectedPrice && building === selectedBuilding) {
                option.selected = true;
            }
            priceSelect.appendChild(option);
        });
    };

    const updateDownPaymentLabels = (price) => {
        Array.from(downSelect.options).forEach((option) => {
            const down = parseInt(option.value, 10) || 0;
            const percentage = price > 0 ? Math.round((down / price) * 100) : 0;
            option.textContent = `${down.toLocaleString('ja-JP')}万円(約${percentage}%)`;
        });
    };

    const calcMonthly = (principalYen, rate, term) => {
        if (principalYen <= 0 || term <= 0) return 0;
        const r = rate / 100 / 12;
        const n = term * 12;

        // 0% の場合も計算できるよう、元金均等の月額を返す。
        if (r === 0) return principalYen / n;

        const factor = Math.pow(1 + r, n);
        return principalYen * r * factor / (factor - 1);
    };

    const getNonNegativeNumber = (value, maximum = Number.POSITIVE_INFINITY) => {
        const number = Number.parseFloat(value);
        if (!Number.isFinite(number) || number < 0) return 0;
        return Math.min(number, maximum);
    };

    const update = () => {
        const price = parseInt(priceSelect.value, 10) || 0;
        const rate = getNonNegativeNumber(rateSelect?.value, 100);
        const term = Math.min(Math.max(parseInt(termSelect?.value, 10) || 0, 0), 100);
        const down = getNonNegativeNumber(downSelect?.value, price);

        updateDownPaymentLabels(price);

        const borrowing = Math.max(0, price - down);
        // ボーナス返済額は「1回あたり（年2回）」として扱い、
        // その返済分の現在価値を借入額から差し引いて通常月の支払額を算出する。
        const bonusMan = getNonNegativeNumber(bonusInput?.value, borrowing);
        const monthlyRate = rate > 0 ? rate / 100 / 12 : 0;
        const bonusCount = term > 0 ? term * 2 : 0;
        let bonusPrincipalYen = 0;

        if (bonusMan > 0 && bonusCount > 0) {
            const bonusYen = bonusMan * 10000;
            const sixMonthRate = Math.pow(1 + monthlyRate, 6) - 1;
            bonusPrincipalYen = sixMonthRate > 0
                ? bonusYen * (1 - Math.pow(1 + sixMonthRate, -bonusCount)) / sixMonthRate
                : bonusYen * bonusCount;
        }

        const normalPrincipalYen = Math.max(0, borrowing * 10000 - bonusPrincipalYen);
        const monthlyYen = calcMonthly(normalPrincipalYen, rate, term);
        const monthlyMan = Math.round(monthlyYen / 10000 * 10) / 10;

        if (borrowingEl) borrowingEl.textContent = borrowing.toLocaleString('ja-JP');
        if (resultEl) resultEl.textContent = monthlyMan.toFixed(1);
    };

    triggers.forEach((trigger) => {
        trigger.addEventListener('click', () => {
            const selectedPrice = parseInt(trigger.dataset.monthlyPrice, 10) || 0;
            populatePriceOptions(selectedPrice, getBuildingLabel(trigger));
            update();
        });
    });

    [priceSelect, rateSelect, termSelect, downSelect].forEach((el) => {
        if (el) el.addEventListener('change', update);
    });

    if (bonusInput) {
        bonusInput.addEventListener('input', update);
    }

    update();
};

export default monthlyPaymentModal;
